import React from 'react';
import {Col, Row} from 'react-bootstrap';
import OpenIcon from '../../Measures/img/Arrow.svg';
import {t} from 'react-switch-lang';

const SectionHeader = ({data, open, toggleOpen, value}) => {
  return (
    <div className="section-header  justify-content-between align-items-center">
      <div className="hover-effect  align-items-center">
        <div
          className="section-icon"
          onClick={(event) => toggleOpen(event)}
          id={value}
        >
          <img
            src={OpenIcon}
            className={`${open && 'open'}`}
            alt="Icon"
            onClick={(event) => toggleOpen(event)}
            id={value}
          />
        </div>
      </div>
      <div className=" px-0 section-header-info">
        {!open ? (
          <Row className="m-0 pt-3 info">
            <Col md={1} style={{minWidth: '14.28%',wordBreak: 'break-word'}}>
              <p className="info-header">{t('controls.controlName')}</p>
              <p className="info-data">{data?.name}</p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%',wordBreak: 'break-word'}}>
              <p className="info-header">{t('controls.controlDescription')}</p>
              <p className="info-data">{data?.description}</p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('controls.purposeLabel')}</p>
              <p className="info-data">
                  {t(`controls.${data?.purpose.toLowerCase()}`)}
              </p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">{t('controls.controlType')}</p>
              <p className="info-data">
                  {t(`controls.${data?.type.toLowerCase()}`)}
              </p>
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">
                {t('controls.controlFrequency')}
              </p>
                {t(`controls.${data?.frequency.toLowerCase()}`)}
            </Col>
            <Col md={1} style={{minWidth: '14.28%'}}>
              <p className="info-header">
                {t('controls.controlRate')}
              </p>
                {t(`controls.${data?.controlAssessment.toLowerCase()}`)}
            </Col>
              <Col md={1} style={{minWidth: '14.28%',wordBreak: 'break-word'}}>
                  <p className="info-header">
                      {t('controls.controlEvidence')}
                  </p>
                  {data?.evidence}
              </Col>
          </Row>
        ) : (
          ''
        )}
      </div>
    </div>
  );
};

export default SectionHeader;
